import { SESSION_PARAMETERS } from "@pdfking/constants/settings"
import { RecordMap } from "@pdfking/tfunc"
import encode from "./encode"

type UserData = { [K in keyof typeof SESSION_PARAMETERS]: unknown }

export default function user_get(string?: string): UserData {
  if (string) {
    const data = encode.loads(string)

    return RecordMap(
      v => data[v],
      SESSION_PARAMETERS
    )
  } else {
    return {
      cart_counter: 0,
      email: null,
      has_discount: false,
      id: null,
      is_staff: false,
      name: null,
      signup_time: 0,
    }
  }
}
